import { Button, ButtonProps } from "@chakra-ui/react";
import React, { forwardRef } from "react";

export const ToolbarButton = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  return (
    <Button
      ref={ref}
      size="sm"
      height="32px"
      minHeight="32px"
      borderRadius="6px"
      fontSize="14px"
      variant={props.variant || "outline"}
      color="var(--white)"
      borderColor={props.variant === "outline" ? "var(--gray)" : undefined}
      bg={props.variant === "ghost" ? "transparent" : "var(--black)"}
      _hover={{ 
        bg: "var(--dark-gray)", 
        borderColor: props.variant === "outline" ? "var(--accent)" : undefined 
      }}
      _active={{ bg: "rgba(255, 255, 255, 0.08)" }}
      _focusVisible={{ 
        outline: "2px solid var(--accent)", 
        outlineOffset: "2px",
        bg: "var(--dark-gray)" 
      }}
      _disabled={{ 
        opacity: 0.6, 
        cursor: "not-allowed",
        _hover: { bg: undefined }
      }}
      transition="all 0.2s"
      {...props}
    />
  );
});

ToolbarButton.displayName = "ToolbarButton";

